import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { NotificationContext } from '../components/Layout';
import { getTheme } from '../utils/theme';

const theme = getTheme();

export default function FeedbackPage() {
  const navigate = useNavigate();
  const { showNotification } = useContext(NotificationContext) || {};
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setLoading(true);
    try {
      await api.post('/feedback/', { message });
      showNotification?.('Feedback submitted successfully. Thank you!');
      setMessage('');
      navigate(-1);
    } catch (err) {
      alert('Failed to submit feedback');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.root}>
      <div style={S.container}>
        <div style={S.header}>
          <button style={S.backBtn} onClick={() => navigate(-1)}>← Back</button>
          <h1 style={S.title}>Send Feedback</h1>
        </div>
        <p style={{ color: '#94a3b8', fontSize: 13, marginBottom: 20 }}>
          Have suggestions, found a bug, or just want to say hi? We'd love to hear from you!
        </p>

        <form onSubmit={handleSubmit}>
          <textarea
            style={S.textarea}
            rows={6}
            placeholder="Type your feedback here..."
            value={message}
            onChange={e => setMessage(e.target.value)}
            required
            autoFocus
          />
          <button type="submit" style={S.submitBtn} disabled={loading || !message.trim()}>
            {loading ? 'Submitting...' : 'Submit Feedback'}
          </button>
        </form>
      </div>
    </div>
  );
}

const S = {
  root: { flex: 1, overflowY: 'auto', background: '#0f0f13', padding: '0 0 60px' },
  container: { maxWidth: 680, margin: '0 auto', padding: '0 16px' },
  header: { display: 'flex', alignItems: 'center', gap: 12, padding: '20px 0 16px' },
  backBtn: { background: 'none', border: 'none', color: theme.colors.primaryHover, cursor: 'pointer', fontSize: 13, padding: 0 },
  title: { margin: 0, fontSize: 18, fontWeight: 700, color: '#e2e8f0' },
  textarea: { width: '100%', padding: '14px', borderRadius: 10, border: '1px solid #2d2d3d', background: '#16161d', color: '#e2e8f0', fontSize: 13, outline: 'none', resize: 'vertical', boxSizing: 'border-box', marginBottom: 16, fontFamily: 'inherit' },
  submitBtn: { width: '100%', padding: '13px', borderRadius: 10, border: 'none', background: theme.colors.gradient, color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer' },
};
